import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

//redux
import { useSelector, useDispatch } from "react-redux";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { getAdmin, getNavigation, statusNavigation } from "helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";


const AdminList = () => {

  const router = useNavigate();
  const [isLoading, setLoading] = useState(false)
  const [list, setList] = useState([])

  const getList = () => {
    setLoading(true)
    getAdmin().then((res) => {
      setList(res)
      setLoading(false)
    }).catch((err) => {
      console.log('err', err)
      setLoading(false)
    })
  }



  useEffect(() => {
    getList()
  }, []);

  const handleNewClicks = () => {
    router("/create-admin")
  };



  const columns = useMemo(
    () => [
      {
        header: "SNO",
        accessorKey: "admin_id",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell, row) => {
          return (
            <>
              <h5 className='font-size-14 mb-1'>
                {cell.row.index + 1}
              </h5>
            </>
          )
        }
      },

      {
        header: 'Name',
        accessorKey: 'name',
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        header: 'User Type 1',
        accessorKey: 'user_type1',
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        header: 'User Type 2',
        accessorKey: 'user_type2',
        enableColumnFilter: false,
        enableSorting: false,
      }, 

            {
              header: 'Action',
              enableColumnFilter: false,
              enableSorting: false,
              cell: (cellProps) => {
                return (
                  <div className="d-flex gap-3">
                        <Link
                          to="/create-admin"
                          state={{ id: cellProps.row.original.admin_id}}
                          className="text-primary"
                        >
                          <i className="mdi mdi-eye font-size-18" id="deletetooltip" />
                        </Link> 
                  </div>
                );
              }
            },

    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="" breadcrumbItem="ADMIN LIST" />
          <Row>
            {
              isLoading ? <Spinners setLoading={setLoading} />
                :
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <TableContainer
                        columns={columns}
                        data={list || []}
                        isGlobalFilter={true}
                        isPagination={true}
                        SearchPlaceholder="Search..."
                        isCustomPageSize={true}
                        isAddButton={true}
                        handleUserClick={handleNewClicks}
                        buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
                        buttonName="Add ADMIN"
                        tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                        theadClass="table-light"
                        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                        pagination="pagination"
                      />
                    </CardBody>
                  </Card>
                </Col>
            }
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default withRouter(AdminList);